
import Vue from 'vue'
import { mains, subs } from '@/assets/menu'
import { IMenuProps } from '@/entities/Menu'

const component = Vue.extend({
  data() {
    return {
      menus: mains,
      subs
    }
  },
  computed: {
    __current(): string | null {
      return this.$route.name?.split('-')[0] || null
    }
  },
  methods: {
    authority(menu: IMenuProps): boolean {
      // chatgptはフラグによって表示するしないが決定
      if (menu.id === 'chatgpt' && !this.App.hospital.current?.flags?.chatgpt) {
        return false
      }

      // ユーザーロールによって見れないページのときはfalse
      const role = this.App.doctor.current?.flags.superuser ? 'superuser' : this.App.doctor.current?.role
      return !(menu.policy && !menu.policy.includes(role || 'admin'))
    }
  }
})

Vue.component('MNavigationDrawer', component)
export default component
